<template>
  <el-dialog
    title="修改机台"
    :visible.sync="machineEditVisible"
    width="50%"
    :close-on-click-modal="false"
  >
    <el-form
      :model="machine"
      :rules="machineRelues"
      ref="machineaEditForm"
      label-width="145px"
    >
      <el-form-item label="机台归类:" prop="machineKind">
        <el-select v-model="machine.machineKind" clearable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机台编号:" prop="number">
        <el-input v-model="machine.number"></el-input>
      </el-form-item>
      <el-form-item label="所在车间:" prop="workshop">
        <el-input v-model="machine.workshop"></el-input>
      </el-form-item>
      <el-form-item label="轴长(米):" prop="warpKnittingMachineAxialLength">
        <el-input v-model="machine.warpKnittingMachineAxialLength"></el-input>
      </el-form-item>
      <el-form-item label="面梳(个):" prop="warpKnittingMachineMaxComb">
        <el-input v-model="machine.warpKnittingMachineMaxComb"></el-input>
      </el-form-item>
      <el-form-item label="机台类型:" prop="machineType">
        <el-input v-model="machine.machineType"></el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input v-model="machine.remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="onSubmit()">修改</el-button>
      <el-button @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as api from "@/api/factory/machine/list/edit";
export default {
  data() {
    var lengthruler = (rules, value, cb) => {
      const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/;
      if (ruler.test(value)) {
        return cb();
      }
      cb(new Error("请输入大于0的正整数"));
    };
    return {
      machineEditVisible: false,
      options: [
        {
          value: 0,
          label: "经编机",
        },
        {
          value: 1,
          label: "整经机",
        },
      ],
      machine: {},
      machineRelues: {
        number: [
          {
            required: true,
            message: "请输入机台编号",
            trigger: "blur",
          },
        ],
        workshop: [
          {
            required: true,
            message: "请输入所属车间",
            trigger: "blur",
          },
        ],
        warpKnittingMachineAxialLength: [
          {
            required: true,
            message: "请输入轴长",
            trigger: "blur",
          },
          {
            validator: lengthruler,
            trigger: "blur",
          },
        ],
        warpKnittingMachineMaxComb: [
          {
            required: true,
            message: "请输入面梳",
            trigger: "blur",
          },
          {
            validator: lengthruler,
            trigger: "blur",
          },
        ],
        machineType: [
          {
            required: true,
            message: "请输入机台类型",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 外部调用，显示修改机台弹框
    show(machineId) {
      this.machine.id = machineId;
      this.getEquipData();
      this.machineEditVisible = true;
    },
    // 获取机台信息
    getEquipData() {
      const data = {
        machineIds: [this.machine.id],
      };
      api.getEquipData(data).then((res) => {
        this.machine = res.data[0];
      });
    },
    // 点击创建按钮，创建机台
    onSubmit() {
      this.$refs.machineaEditForm.validate((valid) => {
        if (!valid) return;
        api.onSubmit(this.machine).then((res) => {
          this.$Message.success("机台编辑成功!");
          this.$emit("update");
          this.machineEditVisible = false;
        });
      });
    },
    // 取消按钮
    cancel() {
      this.machineEditVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
